import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1079.000000 1074.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >



<path d="M2684 7039 c-52 -12 -107 -61 -133 -119 -18 -39 -21 -66 -21 -191 0
-141 1 -149 28 -200 19 -38 41 -61 75 -82 44 -27 57 -29 189 -37 145 -9 305
-34 323 -51 5 -5 18 -9 30 -9 24 0 160 -63 231 -107 75 -46 183 -141 232 -205
116 -150 194 -350 207 -528 29 -393 -54 -666 -269 -888 -188 -195 -420 -286
-791 -311 -102 -7 -151 -20 -166 -44 -4 -5 -12 -6 -18 -3 -11 7 -16 261 -5
289 4 13 11 13 48 2 150 -45 369 -20 521 62 221 118 368 317 406 547 17 109 7
302 -21 391 -41 129 -105 233 -204 328 -121 116 -270 187 -440 209 -66 8 -103
7 -190 -6 -60 -9 -112 -13 -117 -10 -5 3 -9 92 -9 199 0 107 -4 196 -8 199 -4
2 -99 6 -209 7 -153 2 -206 -1 -217 -11 -14 -10 -16 -44 -16 -214 0 -144 3
-205 12 -214 8 -8 63 -12 177 -12 148 -1 164 -2 146 -16 -150 -109 -188 -141
-233 -197 -60 -74 -125 -198 -143 -272 -6 -28 -16 -54 -20 -60 -5 -5 -9 -24
-9 -42 0 -36 5 -35 -100 -35 l-65 0 -3 55 c-2 30 -9 60 -16 66 -9 8 -81 11
-222 9 l-209 -3 -3 -209 c-2 -145 1 -213 9 -222 15 -19 409 -20 427 -2 7 7 12
36 12 64 0 60 8 66 82 63 70 -3 88 -9 88 -32 0 -11 9 -52 21 -91 60 -202 165
-345 336 -457 42 -27 74 -50 72 -51 -2 -1 -83 -4 -179 -7 l-175 -6 -3 -195
c-1 -107 0 -205 3 -217 5 -23 7 -23 195 -23 l190 0 0 -150 c0 -164 8 -201 58
-253 15 -16 45 -38 67 -49 37 -19 52 -20 240 -15 110 3 211 8 225 11 14 4 57
11 95 17 70 10 223 48 300 74 370 123 679 358 881 666 96 147 177 346 209 512
8 45 20 105 26 134 17 84 14 443 -5 553 -24 143 -35 186 -68 285 -112 331
-317 596 -610 793 -138 93 -287 164 -463 221 -81 26 -132 38 -300 71 -62 13
-307 30 -395 29 -36 -1 -83 -5 -106 -10z"/>
<path d="M8396 6660 l-89 -5 -63 -140 c-35 -77 -76 -169 -93 -205 -61 -132
-121 -270 -121 -280 0 -6 -4 -10 -9 -10 -5 0 -11 -10 -15 -23 -3 -13 -42 -104
-87 -203 -73 -161 -94 -209 -131 -294 -6 -14 -19 -41 -28 -60 -10 -19 -21 -45
-25 -58 l-7 -23 122 3 c145 4 115 -30 234 261 l15 37 330 0 c227 0 331 -3 331
-11 0 -5 11 -34 24 -62 13 -29 41 -91 61 -139 l37 -88 125 0 c149 0 145 -26
29 222 -20 42 -36 79 -36 82 0 2 -15 37 -34 78 -18 40 -53 116 -76 168 -23 52
-56 124 -72 159 -17 35 -49 107 -73 160 -113 255 -187 417 -195 425 -11 11
-40 12 -154 6z m114 -432 c40 -95 85 -200 100 -233 44 -98 52 -123 45 -135 -8
-13 -452 -13 -460 0 -3 4 7 34 21 66 14 33 35 82 46 109 33 79 54 126 77 177
11 26 21 49 21 52 0 13 62 136 69 136 5 0 41 -78 81 -172z"/>
<path d="M4920 6011 l0 -651 304 0 c168 0 339 5 381 11 144 20 264 68 360 146
98 80 155 165 198 293 30 89 31 305 3 395 -65 210 -207 351 -425 422 -74 25
-84 26 -448 30 l-373 5 0 -651z m653 438 c185 -28 335 -165 366 -333 31 -167
-12 -317 -121 -423 -24 -23 -79 -59 -123 -80 l-80 -38 -230 0 -230 0 -3 430
c-1 237 0 436 3 443 6 16 314 17 418 1z"/>
<path d="M6678 6622 c-9 -20 -60 -134 -113 -252 -53 -118 -112 -248 -131 -288
-19 -40 -34 -75 -34 -78 0 -3 -16 -40 -36 -82 -20 -42 -62 -135 -94 -207 -106
-238 -120 -270 -135 -298 -29 -55 -26 -57 104 -57 l118 0 62 141 c33 77 61
145 61 150 0 5 136 9 333 9 l333 0 24 -52 c12 -29 36 -82 53 -118 16 -36 36
-80 43 -97 l14 -33 119 0 118 0 23 53 c13 28 38 86 55 127 18 41 58 134 90
205 32 72 69 157 82 190 32 76 197 453 230 524 14 29 31 72 39 94 8 22 18 45
23 51 5 6 12 21 15 34 7 22 7 22 -112 22 l-119 0 -28 -62 c-15 -35 -45 -102
-66 -151 -22 -48 -39 -89 -39 -91 0 -3 -15 -38 -34 -79 -19 -40 -70 -157 -114
-258 -112 -257 -150 -339 -159 -339 -5 0 -32 60 -62 133 -30 72 -74 174 -98
225 -24 52 -43 96 -43 98 0 4 -123 290 -175 409 -7 17 -21 49 -30 73 l-17 42
-142 0 -141 -1 -17 -37z m160 -274 c109 -237 213 -479 207 -488 -8 -13 -434
-14 -454 -1 -16 10 -13 19 39 136 15 33 53 121 84 195 66 158 86 200 96 200 5
0 17 -19 28 -42z"/>
<path d="M5747 5323 c-4 -3 -7 -118 -7 -255 0 -173 -3 -248 -11 -248 -6 0 -31
18 -56 40 -75 66 -137 85 -278 84 -97 0 -130 -4 -171 -20 -136 -55 -243 -166
-285 -296 -18 -57 -21 -84 -17 -190 3 -118 5 -126 41 -200 84 -173 238 -267
437 -268 117 0 221 38 298 109 19 17 38 29 43 26 5 -4 9 -33 9 -66 l0 -60 83
3 c45 2 81 6 80 11 -2 4 -3 306 -3 672 l0 665 -78 0 c-43 0 -82 -3 -85 -7z
m-210 -544 c69 -25 129 -80 169 -153 27 -47 29 -59 29 -161 0 -127 -18 -181
-83 -248 -45 -47 -88 -70 -172 -91 -59 -15 -69 -15 -130 0 -115 29 -173 73
-223 168 -29 57 -31 68 -31 166 0 118 15 166 73 233 87 99 237 134 368 86z"/>
<path d="M7108 5048 l-3 -103 -77 -3 -78 -3 0 -69 0 -70 80 0 80 0 0 -298 c0
-335 5 -369 65 -439 57 -67 111 -87 235 -88 88 0 113 4 153 22 38 18 47 27 47
48 0 23 -35 105 -44 105 -3 0 -25 -9 -51 -20 -106 -45 -203 -5 -230 95 -10 34
-18 530 -9 557 4 15 23 18 142 20 l137 3 0 65 0 65 -137 3 -137 3 -6 33 c-4
18 -5 66 -3 105 l3 71 -82 0 -82 0 -3 -102z"/>
<path d="M6340 4943 c-52 -10 -174 -53 -216 -78 -51 -30 -54 -46 -19 -97 14
-20 25 -42 25 -47 0 -17 19 -13 56 9 113 70 301 92 399 46 85 -39 130 -115
123 -204 l-3 -37 -220 -5 c-139 -4 -227 -10 -240 -17 -11 -7 -36 -19 -55 -28
-93 -41 -139 -118 -140 -231 0 -168 114 -269 320 -281 140 -9 235 20 313 95
l37 36 0 -62 0 -62 80 0 81 0 -3 358 -3 357 -26 55 c-64 138 -190 201 -389
199 -52 -1 -106 -4 -120 -6z m368 -608 c2 -61 -1 -75 -23 -110 -50 -77 -148
-125 -253 -125 -83 0 -131 17 -175 61 -39 39 -39 40 -35 104 4 58 7 67 37 94
47 42 91 49 281 48 l165 -2 3 -70z"/>
<path d="M7885 4940 c-94 -18 -215 -69 -244 -103 -7 -10 -3 -28 18 -67 16 -30
34 -56 40 -58 6 -2 24 6 40 18 63 44 139 63 256 64 88 1 117 -3 147 -18 61
-30 94 -71 113 -141 29 -108 39 -103 -213 -107 l-217 -3 -65 -31 c-87 -41
-133 -94 -150 -174 -44 -205 99 -350 345 -350 118 0 205 29 279 95 16 14 32
23 34 20 6 -5 10 -34 11 -77 l1 -28 76 0 75 0 -3 363 c-3 343 -4 364 -24 407
-43 93 -123 157 -229 185 -62 16 -217 19 -290 5z m377 -542 c3 -7 6 -34 7 -59
7 -132 -122 -239 -287 -239 -160 0 -252 107 -196 226 32 67 85 82 305 83 125
1 168 -2 171 -11z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
